'use strict';

var _ = require('lodash');
var ReoptPreviewDataUtilsService = function ReoptPreviewDataUtilsService(momentService) {
  function getMdReopt(reoptPreviewData) {
    return reoptPreviewData && reoptPreviewData.mdReopt;
  }
  function getNdReopt(reoptPreviewData) {
    return reoptPreviewData && reoptPreviewData.ndReopt;
  }
  function isMdReopt(reoptPreviewData) {
    return !!getMdReopt(reoptPreviewData);
  }
  function isNdReopt(reoptPreviewData) {
    return !!getNdReopt(reoptPreviewData);
  }
  function isMdReoptPreview(reoptPreviewData) {
    var previewStatus = getMdReopt(reoptPreviewData);
    return !!(previewStatus && previewStatus.read);
  }
  function isNdReoptPreview(reoptPreviewData) {
    var previewStatus = getNdReopt(reoptPreviewData);
    return !!(previewStatus && previewStatus.read);
  }
  function isPreview(reoptPreviewData) {
    return isMdReoptPreview(reoptPreviewData) || isNdReoptPreview(reoptPreviewData);
  }
  function isNdReoptSubmitted(reoptPreviewData) {
    var previewStatus = getNdReopt(reoptPreviewData);
    return previewStatus && !previewStatus.read;
  }
  function isMdReoptSubmitted(reoptPreviewData) {
    var previewStatus = getMdReopt(reoptPreviewData);
    return previewStatus && !previewStatus.read;
  }
  function clearFlightDetails(reoptPreviewData) {
    reoptPreviewData.flightDetails = [];
  }
  function updateFlightDetails(reoptPreviewData, gridPanelScope, selectedRows) {
    var flightManagementGridIds = ['inventory-management', 'overbooking-management'];
    if (!_.includes(flightManagementGridIds, gridPanelScope.gridId)) {
      clearFlightDetails(reoptPreviewData);
    }
    var index = _.findIndex(reoptPreviewData.flightDetails, {
      gridId: gridPanelScope.gridId
    });
    var loadedData = _.get(gridPanelScope, 'jqxGridSettings.source.loadedData', []);
    if (index === -1) {
      reoptPreviewData.flightDetails.push({
        loadedData: loadedData,
        selectedRows: selectedRows,
        gridId: gridPanelScope.gridId,
        jqxGridSettings: gridPanelScope.jqxGridSettings
      });
    } else {
      reoptPreviewData.flightDetails[index].loadedData = loadedData;
      reoptPreviewData.flightDetails[index].selectedRows = selectedRows;
    }
  }
  function getFlightDetails(reoptPreviewData, gridPanelScope) {
    var index = _.findIndex(reoptPreviewData.flightDetails, {
      gridId: gridPanelScope.gridId
    });
    if (index === -1) {
      return;
    }
    return reoptPreviewData.flightDetails[index];
  }
  function resetNdReoptPreview(reoptPreviewData) {
    reoptPreviewData.ndReopt = null;
  }
  function resetMdReoptPreview(reoptPreviewData) {
    reoptPreviewData.mdReopt = null;
  }
  function initNdReopt(reoptPreviewData, selectedRow) {
    reoptPreviewData.ndReopt = _.clone(selectedRow);
    reoptPreviewData.ndReopt.date = momentService.copy(reoptPreviewData.ndReopt.flightDepartureDateMoment, momentService.FIELD.ND_DEPARTURE_DATE).toISOString();
  }
  function initMdReopt(reoptPreviewData, selectedRow, legDateSelected) {
    reoptPreviewData.mdReopt = _.clone(selectedRow);
    reoptPreviewData.mdReopt.flightGridsLegDateSelected = legDateSelected;
    reoptPreviewData.mdReopt.date = momentService.copy(reoptPreviewData.mdReopt.departureDateMoment, momentService.FIELD.ND_DEPARTURE_DATE).toISOString();
  }
  function getServiceIdsSearchCriteriaRule(reoptPreviewData) {
    return reoptPreviewData.serviceIdsSearchCriteriaRule;
  }
  function setServiceIdsSearchCriteriaRule(reoptPreviewData, serviceFilter) {
    reoptPreviewData.serviceIdsSearchCriteriaRule = serviceFilter;
  }
  function getSelectedLegDate(legCabins) {
    return _.chain(legCabins).groupBy(function (legCabin) {
      return legCabin.leg + legCabin.optGroupDateMoment.toString();
    }).keys().head().value();
  }
  function shouldUndoMdReopt(reoptPreviewData, legCabins) {
    var mdReoptLegDateSelected = _.get(reoptPreviewData, 'mdReopt.flightGridsLegDateSelected');
    var selectedLegDate = getSelectedLegDate(legCabins);
    return selectedLegDate && mdReoptLegDateSelected && selectedLegDate !== mdReoptLegDateSelected;
  }
  return {
    initNdReopt: initNdReopt,
    initMdReopt: initMdReopt,
    isMdReoptPreview: isMdReoptPreview,
    isNdReoptPreview: isNdReoptPreview,
    isPreview: isPreview,
    isMdReopt: isMdReopt,
    isNdReopt: isNdReopt,
    isNdReoptSubmitted: isNdReoptSubmitted,
    isMdReoptSubmitted: isMdReoptSubmitted,
    updateFlightDetails: updateFlightDetails,
    clearFlightDetails: clearFlightDetails,
    getFlightDetails: getFlightDetails,
    resetNdReoptPreview: resetNdReoptPreview,
    resetMdReoptPreview: resetMdReoptPreview,
    getServiceIdsSearchCriteriaRule: getServiceIdsSearchCriteriaRule,
    setServiceIdsSearchCriteriaRule: setServiceIdsSearchCriteriaRule,
    shouldUndoMdReopt: shouldUndoMdReopt
  };
};
ReoptPreviewDataUtilsService.$inject = ['MomentService'];
module.exports = ReoptPreviewDataUtilsService;